module.exports = __webpack_public_path__ + "img/japan-transport-accidents-male.65ec5568.png";